module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_2.jpg?79576858";